import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'katex/dist/katex.min.css'
import App from './App.vue'
import router from './router'
import { canWrite, READONLY_TIP } from './utils/perm'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

// ——— 按钮级权限指令 v-has-perm ———
// 用法：
//   <el-button v-has-perm="'sales.out.submit'">提交</el-button>
//   <el-button v-has-perm="['sales.out.submit','sales.out.approve']">操作</el-button>
//
// 权限判断逻辑：
//   menu_perm === null     → 系统管理员，全部可见可操作
//   btn_perm 为空          → 仅查看，写操作不可用
//   btn_perm 包含指定值    → 可用；否则 disabled 或隐藏
Vue.directive('has-perm', {
  inserted(el, binding) {
    const perm = binding.value
    if (!perm || perm === true) return  // v-has-perm 无值时放行

    try {
      const raw = localStorage.getItem('profile')
      if (!raw) return
      const profile = JSON.parse(raw)
      const menuPerm = profile.menu_perm
      const btnPerm = profile.btn_perm

      // 系统管理员（menu_perm 为 null）= 不限制
      if (menuPerm === null) return

      // 未配置按钮权限 = 该角色未启用按钮级限制，放行
      if (btnPerm === null || btnPerm === undefined) return

      // 非数组或空数组 = 无写权限
      if (!Array.isArray(btnPerm) || btnPerm.length === 0) {
        disable(el)
        return
      }

      const perms = Array.isArray(perm) ? perm : [perm]
      // btn_perm 含 '*' 表示该角色拥有全部写操作权限
      const hasPerm = perms.some(p => btnPerm.includes(p)) || btnPerm.includes('*')
      if (!hasPerm) {
        disable(el)
      }
    } catch (e) {
      // profile 解析失败时禁用操作按钮
      disable(el)
    }
  }
})

// ——— 只读（仅查看）控制 ———
// 判断逻辑见 utils/perm.js：系统管理员可写，btn_perm 为空的角色仅查看
Vue.prototype.$canWrite = canWrite

// v-can-write：仅查看账号下把写操作按钮置灰（不做 disabled）
// 保留点击事件是为了让 App.vue 的全局拦截给出"当前账号仅有查看权限"提示
Vue.directive('can-write', {
  inserted(el) {
    if (canWrite()) return
    const btn = (el.tagName === 'BUTTON' || el.classList.contains('el-button'))
      ? el
      : el.querySelector('button, .el-button')
    if (btn) {
      btn.classList.add('is-disabled', 'is-readonly-mask')
      btn.setAttribute('title', READONLY_TIP)
      btn.style.opacity = '0.5'
    } else {
      // 非按钮元素（如自定义操作的 a/span）直接隐藏
      el.style.display = 'none'
    }
  }
})

/**
 * 禁用元素（按钮 disabled，其他元素隐藏）
 */
function disable(el) {
  // 直接是 button 或带 el-button class
  if (el.tagName === 'BUTTON' || el.classList.contains('el-button')) {
    el.disabled = true
    el.classList.add('is-disabled')
    return
  }
  // 内部包含按钮的包装容器
  const btn = el.querySelector('button, .el-button')
  if (btn) {
    btn.disabled = true
    btn.classList.add('is-disabled')
    return
  }
  el.style.display = 'none'
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
